import MainAppHUN from './hun/main-app-hun'
import MainAppROM from './rom/main-app-rom'
import MainAppSLO from './slo/main-app-slo'
import { isMarketHun, isMarketRom, isMarketSlo } from 'library/constants'

const MainLayout = () => {
    const renderApp = () => {
        if (isMarketHun) return <MainAppHUN />
        if (isMarketSlo) return <MainAppSLO />
        if (isMarketRom) return <MainAppROM />

        throw new Error('Unknown market')
    }

    return renderApp()
}

export default MainLayout
